<template>
  <div>
    <VoixSiteAuth>
      <VoixPage>
        <VoixRoot />
      </VoixPage>
    </VoixSiteAuth>
  </div>
</template>
